/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Agents_TitleInputs */

const en_cap_agents_title = /** @type {(inputs: Cap_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A team of agents, each with a role and a budget.`)
};

const lv_cap_agents_title = /** @type {(inputs: Cap_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aģentu komanda, katram sava loma un budžets.`)
};

/**
* | output |
* | --- |
* | "A team of agents, each with a role and a budget." |
*
* @param {Cap_Agents_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_agents_title = /** @type {((inputs?: Cap_Agents_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Agents_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_agents_title(inputs)
	return en_cap_agents_title(inputs)
});